/*
* No panelized with spacing dropdown and rails radios
*/
import React from 'react';

import ArrayXQty from './ArrayXQty';
import ArrayYQty from './ArrayYQty';

import SpacingX from './SpacingXTV'
import SpacingY from './SpacingYTV'
import ArrayRails from './ArrayRailsSidesWidth'

const SectionNoPanelized = (props) => (
  <div>
    <div className="row">
      <div className="col-md-6">
        <ArrayXQty {...props} />
      </div>
      <div className="col-md-6">
        <SpacingX {...props} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <ArrayYQty {...props} />
      </div>
      <div className="col-md-6">
        <SpacingY {...props} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <ArrayRails {...props} />
      </div>
    </div>

    <div className="alert alert-info alert-panel-size">
      Panel Size {props.parameters.array_x} x {props.parameters.array_y}
    </div>
  </div>
)

export default SectionNoPanelized;
